import * as _actions from './actions';
import _reducer from './reducer';
import _status from './status';
import _Homework from './model';
import * as _accessors from './accessors';

_Homework.Status = _status;
_Homework.accessors = _accessors;

export const Homework = _Homework;
export const actions = _actions;
export const reducer = _reducer;
export const status = _status;
export const accessors = _accessors;



// WEBPACK FOOTER //
// ./data/Homework/index.js